import { Swiper, Navigation, Pagination, Autoplay } from 'swiper';

export default (elem, args) => {
    // configure Swiper to use modules
    Swiper.use([Navigation, Pagination, Autoplay]);
    // init
    const swiper = new Swiper(elem, args);
};